import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { CollapseBlock, Spinner } from '../../index.jsx';
import { FoBasicInformation } from '../FoBasicInformation.jsx';
import { useFoDateBasicInformation } from '../../../../hooks/useFoDateBasicInformation.jsx';
import { useGetDateQuery } from '../../../../redux/services/fo_dates.jsx';

const DatesDetail = () => {
  const { t } = useTranslation();
  const { dateId } = useParams();
  const { data: dateDetail, isLoading } = useGetDateQuery(dateId);
  const basicInformation = useFoDateBasicInformation(dateDetail);

  return isLoading ? (
    <Spinner />
  ) : (
    <div style={{ margin: '10px' }}>
      <div className="detail-collapse">
        <CollapseBlock title={t('Základné informácie o termíne')}>
          <FoBasicInformation dataToRender={basicInformation} />
        </CollapseBlock>
      </div>
    </div>
  );
};


export default DatesDetail;
